import React from 'react';
import BuzzTable from '../../../components/BuzzTable/BuzzTable';
import { cartColumn } from './columns';
import { Box, Modal } from '@material-ui/core';
import { getAllCartAsync } from './CartStore/cartStoreSlice';
import { useDispatch, useSelector } from 'react-redux';
import AddCartForm from './AddCartForm';
import BuzzPagination from '../../../components/BuzzPagination/BuzzPagination';
import { toast } from 'react-toastify';

const Cart = () => {
  const [open, setOpen] = React.useState(false);
  const [data, setData] = React.useState([]);
  // const handleOpen = () => setOpen(true);
  const [page, setPage] = React.useState(1);
  const handleClose = () => setOpen(false);

  const dispatch = useDispatch();
  const { cart } = useSelector(({ cartReducer }) => {
    return {
      cart: cartReducer.cart && cartReducer.cart.fetchedData,
    };
  });

  React.useEffect(() => {
    fetchData();
  }, []);

  React.useEffect(() => {
    if (cart && Array.isArray(cart)) {
      const filteredData = cart.filter((item) => item.user && item.user.name);
      setData(filteredData);
    }
  }, [cart]);

  const fetchData = async () => {
    try {
      dispatch(
        getAllCartAsync({
          params: { page: 1, limit: 10 },
        })
      )
        .unwrap()
        .then(() => {});
    } catch (err) {
      console.log(err);
    }
  };
  // console.log({ data });
  const handlePageChange = (val) => {
    if (val !== page) {
      setPage(val);
      dispatch(
        getAllCartAsync({
          params: { page: val, limit: 10 },
        })
      )
        .unwrap()
        .then(() => {
          toast.success('All Cart fetched successfully!');
        })
        .catch((err) => {
          toast.error(err.message);
        });
    }
  };
  return (
    <Box>
      {/* <Button onClick={handleOpen} variant="contained" color="primary">
        Add to Cart
      </Button> */}
      <Box mb={4}>
        <BuzzTable columns={cartColumn} data={data} />
        <Box display="flex" justifyContent="center" pb={3}>
          <BuzzPagination
            onClick={handlePageChange}
            total={data.length}
            pageNo={page}
            defaultPage={1}
            perPage={10}
          />
        </Box>
      </Box>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <AddCartForm />
      </Modal>
    </Box>
  );
};

export default Cart;
